// Header.js
import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container, Image, Offcanvas } from 'react-bootstrap';
import { FaHome, FaRoute, FaTools, FaPalette, FaAward, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/images/l.png';

function Header() {
    const [show, setShow] = useState(false);
    const handleToggle = () => setShow(!show);
    const handleClose = () => setShow(false);

    const getLinkClass = ({ isActive }) =>
        `nav-link d-flex align-items-center gap-2 px-3 py-2 ${isActive ? 'active-link' : ''}`;

    return (
        <>
            {/* Mobile header */}
            <div className="mobile-nav d-flex justify-content-between align-items-center px-3 py-2 d-md-none">
                <Link to="/">
                    <Image
                        src={logo}
                        alt="Logo"
                        className="nav-logo"
                        style={{ width: '65px', height: '65px' }}
                    />
                </Link>
                <button className="nav-toggle" onClick={handleToggle}>
                    &#9776;
                </button>
            </div>

            {/* Desktop header */}
            <div className="header-wrapper d-none d-md-block">
                <Container className="d-flex justify-content-between align-items-center h-100 px-2">

                    {/* Logo */}
                    <div className="d-flex align-items-center">
                        <Link to="/">
                            <Image
                                src={logo}
                                alt="Logo"
                                className="header-logo"
                                style={{ width: '65px', height: '65px' }}
                            />
                        </Link>
                    </div>

                    {/* Navigation - horizontal */}
                    <div className="nav-container d-flex flex-row align-items-center gap-4">
                        <NavLink to="/" className={getLinkClass}><FaHome /> Hello</NavLink>
                        <NavLink to="/journey" className={getLinkClass}><FaRoute /> Journey</NavLink>
                        <NavLink to="/toolkit" className={getLinkClass}><FaTools /> Toolkit</NavLink>
                        <NavLink to="/creations" className={getLinkClass}><FaPalette /> Creations</NavLink>
                        <NavLink to="/milestones" className={getLinkClass}><FaAward /> Milestones</NavLink>
                        <NavLink to="/contact" className={getLinkClass}><FaEnvelope /> Reach out</NavLink>
                    </div>
                </Container>
            </div>

            {/* Offcanvas (Mobile menu) */}
            <Offcanvas show={show} onHide={handleClose} placement="end" className="bg-dark text-light">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <Link to="/">
                            <Image
                                src={logo}
                                alt="Logo"
                                style={{ width: '40px', height: '40px' }}
                            />
                        </Link>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column gap-3">
                    <div className="nav-container d-flex flex-column align-items-center gap-2 p-2 w-fit">
                        <NavLink to="/" onClick={handleClose} className={getLinkClass}><FaHome /> Hello</NavLink>
                        <NavLink to="/journey" onClick={handleClose} className={getLinkClass}><FaRoute /> Journey</NavLink>
                        <NavLink to="/toolkit" onClick={handleClose} className={getLinkClass}><FaTools /> Toolkit</NavLink>
                        <NavLink to="/creations" onClick={handleClose} className={getLinkClass}><FaPalette /> Creations</NavLink>
                        <NavLink to="/milestones" onClick={handleClose} className={getLinkClass}><FaAward /> Milestones</NavLink>
                        <NavLink to="/contact" onClick={handleClose} className={getLinkClass}><FaEnvelope /> Reach out</NavLink>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default Header;
